import React from 'react'

import startCase from 'lodash/startCase'

import { Details, Row, Block } from '../details/details'
import { ButtonRow, Button } from '../buttons'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'


import IssueTabsContainer from '../../containers/issues/issue-tabs-container'

class IssueDetails extends React.Component {
  relatedServicesList () {
    return (
      <ul>
        {this.props.services.map(service =>
          <li key={service.id}>
            {service.name}
          </li>
        )}
      </ul>
    )
  }

  issueName (issueStatus) {
    if (issueStatus === 'needs_work') {
      return 'Attention Req.'
    } else if (issueStatus === 'needs_review') {
      return 'Unresolved'
    }
    return startCase(issueStatus)
  }

  dateBlock (issue, submittedBy, resolvedBy) {
    if (issue.status === 'resolved') {
      return (
        <Block title='Resolved On'>
          <p>
            {issue.resolvedAt.format('MMMM Do, YYYY')} by {resolvedBy && resolvedBy.name}
          </p>
        </Block>
      )
    } else {
      return (
        <Block title='Submitted On'>
          <p>
            {issue.submittedAt.format('MMMM Do, YYYY')} by {submittedBy && submittedBy.name}
          </p>
        </Block>
      )
    }
  }

  formattedHistory (history, updatedBy) {
    return (
      <p>
        {history && history.createdAt.format('MMMM Do, YYYY')} by {updatedBy && updatedBy.name}
      </p>
    )
  }

  render () {
    if (this.props.loading) {
      return <div>Loading...</div>
    }

    const {
      issue,
      issueDescription,
      area,
      submittedBy,
      services,
      location,
      latestHistory,
      latestUpdatedBy,
      resolvedBy
    } = this.props

    const permissions = issue.permissions

    let relatedServices = <p>None</p>
    if (services && services.length > 0) {
      relatedServices = this.relatedServicesList()
    }

    return (
      <div>
        <Details>
          <Row>
            <Block title='Area'>
              <p>{area.name}</p>
            </Block>
            <Block title='Description'>
              <p>{issueDescription.name}</p>
            </Block>
            <Block title='Status'>
              <p>{this.issueName(issue.status)}</p>
            </Block>
          </Row>

          <Row>
            <Block title='Notes'>
              <p>
                {issue.notes || 'None'}
              </p>
            </Block>

            {this.dateBlock(issue, submittedBy, resolvedBy)}

            <Block title='Last Updated'>
              {latestHistory
                ? this.formattedHistory(latestHistory, latestUpdatedBy)
                : <p>—</p>
              }
            </Block>
          </Row>

          <Row>
            <Block title='Related Services'>
              {relatedServices}
            </Block>

            <Block title='Images'>
              <ButtonRow>
                <Button
                  small
                  externalUrl={issue.beforeImage.url}
                  disabled={!issue.beforeImage.url}
                >
                  <p>
                    {issue.beforeImage.url ? 'View Before Image' : 'No Before Image'}
                  </p>
                </Button>
              </ButtonRow>
              <ButtonRow>
                <Button
                  small
                  externalUrl={issue.currentImage.url}
                  disabled={!issue.currentImage.url}
                >
                  <p>
                    {issue.currentImage.url ? 'View Current Image' : 'No Current Image'}
                  </p>
                </Button>
              </ButtonRow>
            </Block>
            <Block title='Actions'>
              <ButtonRow>
                <Button
                  small
                  to={`location-issues/${issue.location}/issue/${issue.id}/edit`}
                  disabled={!permissions.canUpdate}
                >
                  Update Issue
                </Button>
              </ButtonRow>
              <ButtonRow>
                <Button
                  small
                  onClick={this.props.onMarkAsPermanent}
                  disabled={!permissions.canMarkAsPermanent}
                >
                  Mark as Permanent
                </Button>
              </ButtonRow>
              <ButtonRow>
                <Button
                  small
                  onClick={this.props.onMarkAsResolved}
                  disabled={!permissions.canMarkAsResolved}
                >
                  Mark as Resolved
                </Button>
              </ButtonRow>
              <ButtonRow>
                <Tooltip
                  overlay={<span>Issue already sent to work order. See history.</span>}
                  placement='bottom'
                  trigger={!permissions.canSendToWorkOrder ? ['hover'] : []}>
                  <Button
                    small
                    to={`location-issues/${issue.location}/issue/${issue.id}/send_to_work_order`}
                    disabled={!permissions.canSendToWorkOrder}>
                    Send to Work Order
                  </Button>
                  </Tooltip>
              </ButtonRow>
            </Block>
          </Row>
        </Details>

        <IssueTabsContainer issue={issue} location={location} />
      </div>
    )
  }
}

export default IssueDetails



// WEBPACK FOOTER //
// ./src/components/issues/issue-details.js